import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import CarrouselClientes from '@/components/CarrouselClientes/CarrouselClientes';
import MyToastShow from '@/components/Layout/MyToast';
import PageTitleWrapper from '@/components/PageTitleWrapper';
import { useState } from 'react';
import {
  useCambiarEmailMutation,
  useInicializarPreciosMutation,
  useSubirFotoMutation
} from '@/redux/api/ConfiguracionApi';
import { convertBase64ToFile, esEmail } from '@/utils/allUtils';

import { useEffect } from 'react';



const CarrouselClientesPage = () => {
  const [preview, setPreview] = useState<string | null | any>(null);
  const [nombre, setNombre] = useState<string>('');
  const [email, setMail] = useState<string>('');
  const [errorMail, setErrorMail] = useState<boolean>(false);
  const [errorNombre, setErrorNombre] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [clicked, setClicked] = useState(false);

  const [subirFoto] = useSubirFotoMutation();
  const [cambiarEmail] = useCambiarEmailMutation();
  const [inicializarPrecios] = useInicializarPreciosMutation();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    InicializarPrecios();
    setOpen(false);
  };

  useEffect(() => {
    if (clicked) {
      if (preview === null) {
        MyToastShow({ message: 'Foto eliminada', type: 'info' });
      }

      setClicked(false);
    }
  }, [preview, clicked]);

  const valid_fields = () => {
    if (!preview) {
      MyToastShow({ message: 'No se ha seleccionado ninguna foto', type: 'error' });
      return false;
    }

    return true;
  };

  const SubirFoto = () => {
    if (!valid_fields()) {
      setErrorNombre(true);
      return;
    }

    const formData = new FormData();
    formData.append('logo', convertBase64ToFile(preview, `${nombre}.png`));
    formData.append('nombreArchivo', nombre);

    subirFoto(formData)
      .then((data) => {
        MyToastShow({ message: 'Foto subida correctamente', type: 'success' });
        setErrorNombre(false);
        setNombre('');
        setPreview(null);
      })
      .catch((error) => {
        MyToastShow({ message: 'Error al subir la foto', type: 'error' });
      });
  };

  const handleImageChange = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];
      let reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(img);
    }
  };



  const handleCloseModal = () => {
    setOpenModal(false);
  };


  const CambiarEmail = () => {
    if (!esEmail(email)) {
      MyToastShow({ message: 'Ingrese un email valido', type: 'error' });
      setErrorMail(true);
      return;
    }

    cambiarEmail(email)
      .then((data) => {
        MyToastShow({ message: 'Email cambiado correctamente', type: 'success' });
        setErrorMail(false);
      })
      .catch((error) => {
        MyToastShow({ message: 'Error al cambiar el email', type: 'error' });
      });
  };


  const InicializarPrecios = () => {
    inicializarPrecios("").then((data) => {
      MyToastShow({ message: 'Precios inicializados, ya puede editarlos', type: 'success' });
    })
      .catch((error) => {
        MyToastShow({ message: 'Error al inicializar los precios', type: 'error' });
      });
  }

  return (
    <>
      <PageTitleWrapper>
        <Typography
          component='h3'
          sx={{
            margin: '0px 0px 4px',
            fontWeight: 700,
            fontSize: '25px',
            lineHeight: 1.4,
          }}
        >
          Carrousel de Clientes
        </Typography>
        <Typography
          component='p'
          sx={{
            margin: '0px',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: 1.4,
            color: 'primary.main',
          }}
        >
          Gestioná el carrousel de los clientes desde esta sección
        </Typography>
      </PageTitleWrapper>

      <Box
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <Paper
          elevation={3}
          sx={{ mb: 5, p: 3, display: 'flex', alignItems: 'center', borderRadius: '5px' }}
        >
          <Grid container spacing={3}>
            <Grid item xs={4} alignItems='center' alignSelf='center' textAlign='center'>
              <img src={preview} style={{ width: '100%' }} alt='preview' />

             
              <Button variant='contained' component='label' htmlFor='upload-photo' sx={{ mt: 2 }}>
                Seleccionar Foto
                <input
                  type='file'
                  accept='image/*'
                  id='upload-photo'
                  style={{ display: 'none' }}
                  onChange={handleImageChange}
                />
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Grid item xs={12}>
                <Typography
                  variant='h5'
                  component='h5'
                  sx={{ fontWeight: 700, fontSize: '20px', lineHeight: 1.4, mb: 2 }}
                >
                  Agregar una foto
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Nombre de la foto (opcional)'
                  variant='standard'
                  error={errorNombre}
                  value={nombre}
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button variant='contained' color='primary' sx={{ mt: 2 }} onClick={SubirFoto}>
                  Subir Foto
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>

        <CarrouselClientes modificable={true} />


        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>Vista previa de la foto</DialogTitle>
          <DialogContent>
            {preview && (
              <img
                src={preview}
                alt='preview'
                style={{ width: '100%', height: 'auto' }}
              />
            )}
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setPreview(null);
                  setClicked(true)
                  handleCloseModal()
                }}
                sx={{ mr: 2 }}
              >
                Deseleccionar Foto
              </Button>


              <Button variant="contained" color="primary" onClick={() => {
                setClicked(true);
                if (preview === null) {
                  MyToastShow({ message: 'Foto eliminada', type: 'info' });
                } else {
                  MyToastShow({ message: 'Foto añadida', type: 'success' });
                }
                handleCloseModal();
              }}>
                Seleccionar
              </Button>


            </Box>
          </DialogContent>
        </Dialog>


        <Paper
          elevation={3}
          sx={{ mb: 5, p: 3, display: 'flex', alignItems: 'center', borderRadius: '5px' }}
          aria-label='RecipientEmailChanger'
        >
          <Grid container spacing={3}>
            <Grid item xs={8}>
              <Grid item xs={12}>
                <Typography
                  variant='h5'
                  component='h5'
                  sx={{ fontWeight: 700, fontSize: '20px', lineHeight: 1.4, mb: 2 }}
                >
                  Cambiar email de recepción de consultas
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Email'
                  variant='standard'
                  error={errorMail}
                  value={email}
                  onChange={(e) => {
                    setMail(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button variant='contained' color='primary' sx={{ mt: 2 }} onClick={CambiarEmail}>
                  Cambiar email
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>


        <Paper elevation={3} sx={{ mb: 5, p: 3, display: 'flex', alignItems: 'center', borderRadius: '5px' }} aria-label='RecipientEmailChanger'>
          <Grid container spacing={3}>
            <Grid item xs={8}>
              <Grid item xs={12}>
                <Typography variant='h5' component='h5' sx={{ fontWeight: 700, fontSize: '20px', lineHeight: 1.4, mb: 0 }}>
                  Inicializar precios en $0
                </Typography>
                <Typography variant='h5' component='h5' sx={{ fontWeight: 700, fontSize: '15px', lineHeight: 1.4, mb: 2 }}>
                  Debe ser clickeado una unica vez para poder editar los precios una vez creada la nueva base de datos.
                  Si se vuelve a clickear una segunda vez, los precios se colocaron nuevamente en $0, sobreescribiendo los precios editados
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button variant='contained' color='primary' sx={{ mt: 2 }} onClick={handleClickOpen}>
                  Inicializar precios
                </Button>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">{"¿Estás seguro que queres inicializar los precios?"}</DialogTitle>
                  <DialogActions>
                    <Button variant='contained' onClick={handleClose} color="warning">
                      Cancelar
                    </Button>
                    <Button variant='contained' onClick={handleConfirm} color="primary" autoFocus>
                      Sí
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </>
  );
};

export default CarrouselClientesPage;